import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { Guid } from './globals';
import { IssueItemContractMap } from './lib/issue/classes';
import { EMailAudit } from './lib/mail/classes';

export interface AbstractItem {
    itemcount: number;
    itemproduct: number;
    itemservice: string;
    itemdesc: string;
    itembuildindate: string;
    itemfaktdate: string;
    itemcanceldate: string;
    itemsetupcost: number;
    itemrentalcost: number;
    itempurchasecost: number;
}

class Audit {
    public auditid: number;
    public audituser: string;
    public audittime: string;
    public auditnote: string;
    public auditaction: string;
}
class DataModel {
    isChanged: boolean = false;
    auditNote: string = null;
    setValue(attr, value) {
        if (typeof (this[attr]) == "undefined") return;
        if (this[attr] != value) {
            this[attr] = value;
            this.isChanged = true;
        }
    }
}
export class AbstractChangeModel {
    public guid: string = Guid.newGuid();
    public lastModified: number = new Date().getTime();
    public auditNote: string;
    public uploadTasks: UploadTask[] = [];
    public scheduleTasks: ScheduleUserTask[] = [];
    public availabilityTasks: AvailabilityTask[] = [];
    public type: number;
    public delete: boolean = false;
}
export class ChangeModel<T> extends AbstractChangeModel {
    public serverModel: T;
    public newModel: T;
    public localState: FormGroup;
    public newModelIsPersisted: boolean = false;
    public changePersistedObservable: Subject<any> = new Subject();
    public allChangesPersistedObservable: Subject<any> = new Subject();
    public changeRejectedObservable: Subject<any> = new Subject();
}
export class AccessDeniedLogEntry {
    public logid: number;
    public logusername: string;
    public logtime: string;
    public logrules: string;
    public logcomponent: string;
    static get url(): string {
        return "api/accesslog";
    }
}
/**
 * @deprecated
 */
export class Address {
    addressid: number = null;
    addressstreet: string = null;
    addresshousenumber: string = null;
    addressnote: string = null;
    addressaddition: string = null;
    addresszipcode: string = null;
    addresscity: string = null;
    addresscountry: string = null;
    isNew: boolean = false;
    isChanged: boolean = false;
    static get url(): string {
        return "api/address";
    }
}
export interface Auditable {

}
export class AuditEntry<T> {
    id: number;
    date: string;
    user: string;
    action: string;
    subject: string;
    note: string;
    transactionid: string;
    oldObject: T;
    newObject: T;
}
export class Availability {
    public availabilityid: number;
    public availabilitylocation: number;
    public availabilitystate: number;
    public availabilitycomponent: number;
    public availabilityState: AvailabilityState;
    public availabilityComponent: AvailabilityComponent;
}
export class AvailabilityState {
    public availabilitystateid: number;
    public availabilitystatename: string;
    public availabilitystatedeliverymin: number;
    public availabilitystatedeliverymax: number;
    public availabilitystatedesc: string;
}
export class AvailabilityComponent {
    public availabilitycomponentid: number;
    public availabilitycomponentname: string;
    public availabilitycomponentrequirement: number;
    public availabilityRequirement: AvailabilityRequirement;
}
export class AvailabilityRequirement {
    public availabilityrequirementid: number;
    public availabilityrequirementname: string;
    public availabilityrequirementdesc: string;
}
/**
 * @deprecated
 */
export class ChangePasswordModel {
    public oldPassword: string;
    public newPassword: string;
    public confirmPassword: string;
}
export class Calendar {
    color: string;
    content: string;
    eTag: string;
    href: string;
    name: string;
    owner: string;
    entries: CalendarEntry[];
}
export class CalendarEntry {
    created: string;
    eTag: string;
    end: string;
    href: string;
    id: string;
    lastModified: string;
    start: string;
    title: string;
    calendar?: Calendar;
    calendarIdentifier: string;
}
export class ChangeType {
    typeid: number;
    typename: string;
    typedesc: string;
}
/**
 * @deprecated
 */
export class ContactPersonal {
    contactpersid: number;
    contactpersfname: string;
    contactperslname: string;
    contactperssalutation: string;
    contactperspublicid: string;
    contactpersondepartment: string;
    contactpersinfo: string;
    contactpersmail: string;
    contactpersphone: string;
    contactpersaddress: number;
    address: Address;
    contactinformation: ContactInformation[];
    customer: Customer[];
    favstate: boolean;
    public isNew: boolean;
    public isChanged: boolean;
    public isValidated: boolean;
}
/**
 * @deprecated
 */
export class ContactInformation {
    public infoid: number;
    public infotype: number;
    public infovalue: string;
    public infocpers: number;
    public contactinformationtype: ContactInformationType;
    public isNew: boolean;
}
export class ContactInformationType {
    public typeid: number;
    public typename: string;
    public typedesc: string;
    public icon: string;
}
/**
 * @deprecated
 */
export class Contract {
    public contractid: number;
    public contractdesc: string;
    public contractstate: number;
    public contracttype: number;
    public contractcustomer: number;
    public contractnote: string;
    public contractnumber: string;
    public contractlocation: number;
    public contractitem: ContractItem[];
    public contractcreation: string;
    public contractcreator: string;
    public favstate: boolean;
    public isChanged: boolean;
    public isNew: boolean;
    static get url(): string {
        return "api/contract";
    }
}
/**
 * @deprecated
 */
export class ContractState {
    public contractstateid: number;
    public contractstatename: string;
    public contractstatedesc: string;
}
/**
 * @deprecated
 */
export class ContractType {
    public contracttypeid: number;
    public contracttypename: string;
    public contracttypedesc: string;
}
/**
 * @deprecated
 */
export class ContractItem {
    public itemid: number;
    public itemname: string;
    public itemfaktdate: string;
    public itembuildindate: string;
    public itemcontractid: number;
    public itemcount: number;
    public itemproduct: number;
    public itemdesc: string;
    public iteminfo: string;
    public itemcanceldate: string;
    public itemsetupcost: number;
    public itempurchasecost: number;
    public itemrentalcost: number;
    public itemlocation: number;
    public itemposition: number;
    public isNew: boolean;
    public isChanged: boolean;
    public contract: Contract;
}

/**
 * @deprecated
 */
export class Customer {
    customerid: number;
    customernumber: string;
    customername: string;
    customerphone: string;
    customerfax: string;
    customermail: string;
    customernote: string;
    customeraddress: number;
    address: Address;
    favstate: boolean;
    issues: Issue[];
    contactpersonal: ContactPersonal[];
    isNew: boolean;
    isValidated: boolean;
    customeractive: boolean;
    concurrencystamp: string;
}
export class CustomerContactpersonLink {
    customer: number;
    contactpersonal: number;
}
export class Draft {

}
/**
 * @deprecated
 */
export class DefaultMail {
    public mailid: number;
    public mailreceiver: string;
    public maildefaultnotification: number;
    public transactionid: number;
    public defaultnotification: DefaultNotification;
    isNew: boolean;
    static get url(): string {
        return "api/defaultmail";
    }
}
/**
 * @deprecated
 */
export class DefaultNotification extends DataModel {
    defaultnotificationid: number = 0;
    defaultnotificationinternal: string;
    defaultnotificationsubject: string;
    defaultnotificationtext: string;
    defaultnotificationlastmodified: string;
    defaultnotificationcreated: string;
    issueTransactionIds: number[] = [];
    isNew: boolean;
    static get url(): string {
        return "api/defaultnotification";
    }
}
export interface Task {
    taskType: number;
}
export class AbstractTask {
    guid: string = Guid.newGuid();
}
export const TaskType = {
    "UploadTask": 1,
    "ScheduleUserTask": 2,
    "NotificationTask": 3,
    "CreateEventTask": 4,
    "MailUploadTask": 5,
    "CreateUserFilterTask": 6,
    "TransformIssueItemsTask": 7
}
export class CreateUserFilterTask extends AbstractTask implements Task {
    public taskType = TaskType.CreateUserFilterTask;
    public filter: WidgetUserFilter;
}
export class TransformIssueItemsTask extends AbstractTask implements Task {
    public taskType = TaskType.TransformIssueItemsTask;
    public maps: IssueItemContractMap[];
}
export class UploadTask extends AbstractTask implements Task {
    public taskType = TaskType.UploadTask;
    public file: AbstractFile;
    public upload: boolean = true;
    public href: string;
}
export class MailUploadTask extends AbstractTask implements Task {
    public taskType = TaskType.MailUploadTask;
    public file: MailAttachement;
    public upload: boolean = true;
    public href: string;
}
export class ScheduleUserTask extends AbstractTask implements Task {
    public taskType = TaskType.ScheduleUserTask;
    public schedule: boolean;
    public user: User;
    public issue: Issue;
    public tempChanged: boolean = false;
}
export class NotificationTask extends AbstractTask implements Task {
    taskType = TaskType.NotificationTask;
    type: any;
    content: string;
    receiver: string[];
    subject: string;
    isDefaultNotification: boolean = false;
    defaultNotification: any;
    attachements: AbstractFile[];
    issueId: number;
}
export const NotificationTaskType = {
    "Internal": { title: "Nachricht im AMS" },
    "EMail": { title: "E-Mail" },
}
export class CreateEventTask extends AbstractTask implements Task {
    taskType = TaskType.CreateEventTask;
    public event: CalendarEntry;
}
export class AvailabilityTask {
    public availability: number;
    public location: number;
    public state: number;
    public component: number;
}
export class AbstractFile {
    isNextcloudFile: boolean = false;
    isLocalFile: boolean = false;
    isMailAttachement: boolean = false;
    type: string;
}
export class LocalFile extends AbstractFile {
    public blob: File;
    public localName: string;
    public size: number;
}
export class MailAttachement extends AbstractFile {
    public blob: Blob;
    public name: string;
    public size: number;
    public id: string;
    public mail: EMailAudit;
}
export class NextcloudFile extends AbstractFile implements Auditable {
    public eTag: string;
    public fileId: string;
    public href: string;
    public isItself: boolean;
    public lastModified: string;
    public size: string;
    public uuid: string;
}
export class UploadMailattachementModel {
    public blob: ArrayBuffer;
    public name: string;
    public type1: string;
    public type2: string;
}
export class GenericPostRequest<T> {
    public note: string;
    public content: T;
    public transaction?: number;
    public time: string;
    public ignoreAttachements: string[];
    public mailsIds: number[];
}
export class HttpErrorResponse {
    error: {
        error: string,
        error_description: string
    };
    status: number;
}
export class Image {
    public mediaType: string;
    public data: any;
    readFromFileUpload(f, callback) {
        const reader = new FileReader();
        reader.onload = ((e) => {
            this.data = window.btoa(<string>(<any>e.target).result);
            if (typeof (callback) == "function") callback(this);
        });
        reader.readAsBinaryString(f);
    }
}
export class Issue implements Auditable {
    public issueid: number;
    public issuecreator: string;
    public issuecreation: string;
    public issuecustomer: number;
    public issuepriority: number;
    public issuecategory: number;
    public issuedesc: string;
    public issuestate: number;
    public issuetitle: string;
    public folderlocation: string;
    public issueescalation: string;
    public issuenumber: number;
    public issuetype: number;
    public changetype: number;
    public commercialcontactpersonalid: number;
    public localcontactpersonalid: number;
    public issuenote: string;
    public customer: Customer;
    public issueitem: IssueItem[] = [];
    public userissueconnection: UserIssueConnection[] = [];
    public _uploads: UploadTask[] = [];
    public _scheduleUserTasks: ScheduleUserTask[] = [];
    public email: IssueMail[];
    public anchestors: number[] = [];
    public followers: number[] = [];
    public isnew: boolean;
    public iswatched: boolean;
    public isassigned: boolean;
    public laststatuschange: string;
    public filesexported: boolean;
    isNew: boolean = false;
    isChanged: boolean = false;
    static get url(): string {
        return "api/issue";
    }
}
export class IssueMail {
    emaildate: string;
    emailmessage: string;
    emailsubject: string;
    emailtransmitter: string;
    emailtransmitteraddress: string;
    emailtype: string;
    id: number;
    issueid: number;
    mailid: string;
}
export class IssueItem {
    public itemid: number;
    public itemname: string;
    public itemcontract: number;
    public itemcount: number;
    public itemproduct: number;
    public itemdesc: string;
    public iteminfo: string;
    public itemposition: number;
    public itemlocation: number;
    public itemsetupcost: number;
    public itemrentalcost: number;
    public itempurchasecost: number;
    public itemissue: number;
    public itemfaktdate: string;
    public itembuildindate: string;
    public itemcanceldate: string;
    public contract: Contract;
    public issue: Issue;
    public isNew: boolean = false;
    public isChanged: boolean = false;
}
export class IssueCategory {
    categoryid: number;
    categoryname: string;
    categorycolor: string;
    categorydesc: string;
    ischangecategory: boolean;
    isincidentcategory: boolean;
    isissuecategory: boolean;
    isprojectcategory: boolean;
}
export class IssueTransactionAttribute {
    id: number;
    name: string;
}
export class IssueState {
    stateid: number;
    statename: string;
    statecolor: string;
    statecode: string;
    stateescalationdays: number;
    isvtstate: boolean;
    iscpstate: boolean;
    ischangestate: boolean;
    isincidentstate: boolean;
    isissuestate: boolean;
    isprojectstate: boolean;
    aspNetRoleIds: number[];
    static get url(): string {
        return "api/issue-status";
    }
}
export class IssueStatisticsModel {
    data: IssueStatisticsTypeMap[] = [];
}
export class IssueStatisticsStateMap {
    state: IssueState;
    count: number;
}
export class IssueStatisticsTypeMap {
    type: IssueType;
    data: IssueStatisticsStateMap[] = [];
}
export class IssueType {
    typeid: number;
    typename: string;
    typecolor: string;
    folderlocation: string;
    static get url(): string {
        return "api/issuetype";
    }
}
/**
 * @deprecated
 */
export class Location {
    public locationid: number;
    public locationfloor: string;
    public locationpart: string;
    public locationparent: number;
    public locationclassification: number;
    public locationinfo: string;
    public locationaddress: number;
    public availability: Availability[];
    public locationClassification: LocationClassification;
    public contractItems: ContractItem[];
    public address: Address;
    public issueItems: IssueItem[];
    public offerItems: OfferItem[];
    public favstate: boolean;
    public accessed: string;
    public isNew: boolean;
}
export class LocationAlias {
    public locationaliasid: number;
    public locationid: number;
    public locationaliastype: number;
    public locationaaliascode: string;
    public location: Location;
    public locationAliasType: LocationAliasType;
}
export class LocationAliasType {
    public typeid: number;
    public typename: string;
    public typedesc: string;
}
export class LocationClassification {
    public classificationid: number;
    public classificationname: string;
    public classificationdesc: string;
    public location: Location[];
}
export class Newsfeed {
    public newsfeedid: number;
    public newsfeedtitle: string;
    public newsfeedicon: string;
    public newsfeedcolor: string;
    public newsfeedobservableconnection: NewsfeedObservableConnection[];
}
export class NewsfeedObservableConnection {
    public newsfeedid: number;
    public observable: string;
}
export class NextcloudAuthorizationLog {
    public auditid: number;
    public auditdate: string;
    public audituser: string;
    public auditcomponent: string;
    public auditerror: string;
}
export class NextcloudSearchRequest {
    public username: string;
    public path: string;
    public newPath: string;
}
export class Notification {
    public notificationid: number;
    public notificationuser: string;
    public notificationsubject: string;
    public notificationtext: string;
    public notificationtime: string;
    public notificationseen: string;
    static get url(): string {
        return "api/notification";
    }
}
export class NotificationModel {
    action: string;
    constructorName: string;
    username: string;
    userId: string;
    receiver: string;
    text: string;
    time: string;
    type: string;
    objectId: number;
    value: boolean;
    message: string;
}
/**
 * @deprecated
 */
export class Offer {
    public offerid: number = null;
    public offertitle: string = null;
    public offerdesc: string = null;
    public offercreator: string = null;
    public offercreation: string = null;
    public offerstate: number = null;
    public offerbillingaddress: number = null;
    public billingaddress: Address;
    public offerserviceaddress: number = null;
    public offernumber: number = null;
    public localcontact: number = null;
    public customoffernote: string = null;
    public commercialcontact: number = null;
    public serviceaddress: Address;
    public offercustomer: number = null;
    public offerissue: number = null;
    public offeritem: OfferItem[] = [];
    public isNew: boolean = false;
    public isChanged: boolean = false;
    static get url(): string {
        return "api/offer";
    }
}
/**
 * @deprecated
 */
export class OfferState {
    public offerstateid: number;
    public offerstatename: string;
    public offerstatecolor: string;
    public offerstatedesc: string;
}
/**
 * @deprecated
 */
export class OfferCreatedResponse {
    offer: Offer;
    items: OfferItem[];
    file: Blob;
}
/**
 * @deprecated
 */
export class OfferItem {
    public itemid: number;
    public itemposition: number;
    public itemdesc: string;
    public iteminfo: string;
    public itemsetupcost: number;
    public itemrentalcost: number;
    public itempurchasecost: number;
    public itemcontract: number;
    public itemproduct: number;
    public itembuildindate: string;
    public itemfaktdate: string;
    public itemcanceldate: string;
    public itemlocation: number;
    public itemterm: string;
    public itemoffer: number;
    public itemProduct: Product;
    public itemcount: number = null;
    public itemselected: boolean;
    public itemissue: number;
    public isChanged: boolean = false;
    public isNew: boolean = false;
    public offer: Offer;
    static get url(): string {
        return "api/offer-item";
    }
}
export class PaginationPage {
    public pageNumber: number;
    public pageSize: number;
}
export class PaginationResponse<T> {
    public content: T;
    public page: PaginationPage;
    public totalItems: number;
}
export class Priority {
    priorityid: number;
    prioritydesc: string;
    prioritycolor: string;
    prioritycode: string;
    priorityname: string;
    ischangepriority: boolean;
    isincidentpriority: boolean;
    isissuepriority: boolean;
    isprojectpriority: boolean;
}
/**
 * @deprecated
 */
export class Product extends DataModel {
    public productid: number = null;
    public productservice: string = null;
    public productdesc: string = null;
    public productnumber: string = null;
    public producttype: string = null;
    public productsetupcost: number = null;
    public productpurchasecost: number = null;
    public productrentalcost: number = null;
    public productgroup: number = null;
    public isNew: boolean = false;
    constructor(o?) {
        super();
        if (o) {
            if (o.productid != null && typeof (o.productid) != "undefined") this.productid = o.productid;
            if (o.productservice != null && typeof (o.productservice) != "undefined") this.productservice = o.productservice;
            if (o.productdesc != null && typeof (o.productdesc) != "undefined") this.productdesc = o.productdesc;
            if (o.productnumber != null && typeof (o.productnumber) != "undefined") this.productnumber = o.productnumber;
            if (o.producttype != null && typeof (o.producttype) != "undefined") this.producttype = o.producttype;
            if (o.productsetupcost != null && typeof (o.productsetupcost) != "undefined") this.productsetupcost = o.productsetupcost;
            if (o.productpurchasecost != null && typeof (o.productpurchasecost) != "undefined") this.productpurchasecost = o.productpurchasecost;
            if (o.productrentalcost != null && typeof (o.productrentalcost) != "undefined") this.productrentalcost = o.productrentalcost;
        }
    }
    static get auditUrl(): string {
        return "api/product/audit";
    }
    static get url(): string {
        return "api/product";
    }
}
export class ProductGroup {
    public productgroupid: number;
    public productgroupnumber: string;
    public productgroupname: string;
    public productgroupparent: number;
    public deepth: number = 0;
    public children: ProductGroup[] = [];
    static get url(): string {
        return "api/productgroup";
    }
}
export class ProductCountModel {
    public product: Product;
    public productId: number;
    public count: number;
}
export class ProductAudit extends Audit {
    public productid: number = null;
    public oldproductservice: string = null;
    public oldproductdesc: string = null;
    public oldproductnumber: string = null;
    public oldproducttype: string = null;
    public oldproductsetupcost: number = null;
    public oldproductpurchasecost: number = null;
    public oldproductrentalcost: number = null;
    public newproductservice: string = null;
    public newproductdesc: string = null;
    public newproductnumber: string = null;
    public newproducttype: string = null;
    public newproductsetupcost: number = null;
    public newproductpurchasecost: number = null;
    public newproductrentalcost: number = null;
    constructor(o?) {
        super();
        if (o) {
            if (o.auditid != null && typeof (o.auditid) != "undefined") this.auditid = o.auditid;
            if (o.auditaction != null && typeof (o.auditaction) != "undefined") this.auditaction = o.auditaction;
            if (o.auditnote != null && typeof (o.auditnote) != "undefined") this.auditnote = o.auditnote;
            if (o.audittime != null && typeof (o.audittime) != "undefined") this.audittime = o.audittime;
            if (o.audituser != null && typeof (o.audituser) != "undefined") this.audituser = o.audituser;
            if (o.productid != null && typeof (o.productid) != "undefined") this.productid = o.productid;
            if (o.oldproductservice != null && typeof (o.oldproductservice) != "undefined") this.oldproductservice = o.oldproductservice;
            if (o.oldproductdesc != null && typeof (o.oldproductdesc) != "undefined") this.oldproductdesc = o.oldproductdesc;
            if (o.oldproductnumber != null && typeof (o.oldproductnumber) != "undefined") this.oldproductnumber = o.oldproductnumber;
            if (o.oldproducttype != null && typeof (o.oldproducttype) != "undefined") this.oldproducttype = o.oldproducttype;
            if (o.oldproductsetupcost != null && typeof (o.oldproductsetupcost) != "undefined") this.oldproductsetupcost = o.oldproductsetupcost;
            if (o.oldproductpurchasecost != null && typeof (o.oldproductpurchasecost) != "undefined") this.oldproductpurchasecost = o.oldproductpurchasecost;
            if (o.oldproductrentalcost != null && typeof (o.oldproductrentalcost) != "undefined") this.oldproductrentalcost = o.oldproductrentalcost;
            if (o.newproductservice != null && typeof (o.newproductservice) != "undefined") this.newproductservice = o.newproductservice;
            if (o.newproductdesc != null && typeof (o.newproductdesc) != "undefined") this.newproductdesc = o.newproductdesc;
            if (o.newproductnumber != null && typeof (o.newproductnumber) != "undefined") this.newproductnumber = o.newproductnumber;
            if (o.newproducttype != null && typeof (o.newproducttype) != "undefined") this.newproducttype = o.newproducttype;
            if (o.newproductsetupcost != null && typeof (o.newproductsetupcost) != "undefined") this.newproductsetupcost = o.newproductsetupcost;
            if (o.newproductpurchasecost != null && typeof (o.newproductpurchasecost) != "undefined") this.newproductpurchasecost = o.newproductpurchasecost;
            if (o.newproductrentalcost != null && typeof (o.newproductrentalcost) != "undefined") this.newproductrentalcost = o.newproductrentalcost;
        }
    }

}
export class ProductPicture {
    public pictureid: number;
    public productid: number;
    public picturemediatype: string;
    public picturedata: string;
    public product: Product;
    static get url(): string {
        return "api/productpicture";
    }
}
export interface Resolvable {
    isResolved: boolean;
    resolvedHandle: Subject<any>;
}
export class ResolvedAuditEntry<T> {
    id: number;
    date: string;
    user: User;
    action: string;
    subject: string;
    note: string;
    transactionid: string;
    fileId: string;
    changes: ResolvedAuditEntryChange[] = [];
    isFileContent: boolean = false;
    isCreate: boolean = false;
    isUpdate: boolean = false;
    isDelete: boolean = false;
    isTransaction: boolean = false;
    isResolved: boolean = true;
    oldObject: T;
    newObject: T;
    prettyAction: string;
    addChange(change: ResolvedAuditEntryChange) {
        this.isResolved = false;
        this.changes.push(change);
        change.resolvedHandle.subscribe(() => this.validate());
    }
    validate() {
        for (let c of this.changes) if (!c.isResolved) this.isResolved = false;
        this.isResolved = true;
    }
}
export class ResolvedAuditEntryChange implements Resolvable {
    attribute: string;
    _n: string;
    set newValue(value: string) {
        this._n = value;
        this.waitForNew = false;
        this.validate();
    }
    get newValue(): string {
        return this._n;
    }
    _o: string;
    set oldValue(value: string) {
        this._o = value;
        this.waitForOld = false;
        this.validate();
    }
    get oldValue(): string {
        return this._o;
    }
    isResolved = false;
    resolvedHandle = new Subject();
    waitForOld = false;
    waitForNew = false;
    hideComparison: boolean = false;
    validate() {
        this.isResolved = (!this.waitForNew && !this.waitForOld);
        if (this.isResolved) this.resolvedHandle.next();
    }
}
export class ResponseWrapper<T> {
    public state: any;
    public content: T;
    public warnings: string[];
    public error: string;
    public errorObject: any;
    constructor(o?) {
        if (o) {
            if (o.state != null && typeof (o.state) != "undefined") this.state = o.state;
            if (o.content != null && typeof (o.content) != "undefined") {
                this.content = o.content;
            }
            if (o.warnings != null && typeof (o.warnings) != "undefined") this.warnings = o.warnings;
            if (o.error != null && typeof (o.error) != "undefined") this.error = o.error;
            if (o.errorObject != null && typeof (o.errorObject) != "undefined") this.errorObject = o.errorObject;
        }
    }
}
export class Role {
    public id: string;
    public name: string;
    public rolerights: RoleRight[];
    public users: User[];
    public isNew: boolean;
    toServerObject(): any {
        return {
            "id": this.id,
            "name": this.name,
            "rolerights": this.rolerights,
            "aspNetUsers": this.users
        };
    }
    static get url(): string {
        return "api/role";
    }
}
export class RoleRight {
    public roleid: string;
    public ruleid: number;
    public value: boolean;
    public rules: Rule;
    public isNew: boolean;
    static get url(): string {
        return "api/security/roleright";
    }
}
export class Rule {
    public ruleid: number;
    public rulecode: string;
    public ruledesc: string;
    public rulename: string;
    public ruleisnecessary: boolean = false;
    public isNew: boolean;
}
export class RuleGroup {
    rulegroupid: number;
    rulegroupname: string;
    rulegroupdesc: string;
    rulegrouppriority: string;
    rulegroupindex: number;
}
export class RuleGroupSet {
    group: RuleGroup;
    rules: Rule[];
}
export class SearchObject {
    searchString: string;
    searchType: number;
}
export class ServerGeneratedIssueId {
    value: number;
    generated: string;
}
export class Setting {
    stgid: number = null;
    stgname: string = null;
    stgvalue: string = null;
    stguser: string = null;
}
export class ShoppingCart {
    guid: string;
    cartid: number;
    cartdescription: string;
    creation: string;
    products: Product[];
    productAddedAnchor: Subject<any> = new Subject();
    addProduct(product: Product) {
        this.products.push(product);
        this.productAddedAnchor.next(this.products);
    }
}
export class Signature {
    signatureid: number;
    signaturedata: string;
    signaturemediatype: string;
}
export class TransformIncidentToIssueRequest {
    incidentId: number;
    issueData: Issue;
}
export class TransformOfferToIssueRequest {
    offerId: number;
    issueData: Issue;
}
export class User {
    public id: string;
    public email: string;
    public userName: string;
    public isNew: boolean;
    public initials: string;
    public roles: Role[] = [];
    public roleIds: string[] = [];
    public profilePictureMediaType: string;
    public profilePicture: string;
    public bannerPictureMediaType: string;
    public bannerPicture: string;
    public lockedOutEnd: string;
    static get url(): string {
        return "api/account";
    }
}
export class UserIsAllowedModel {
    isAllowed: boolean;
    user: User;
    rights: Rule[];
    roles: Role[];
}
export class UserIssueConnection {
    issueid: number;
    userid: string;
    isnew: boolean;
    iswatched: boolean;
    isassigned: boolean;
}
export class UserModel {
    public id: string;
    public userName: string;
    public password: string;
    public confirmPassword: string;
    public initials: string;
    public email: string;
    public profilePictureMediaType: string;
    public profilePicture: string;
    public bannerPictureMediaType: string;
    public bannerPicture: string;
    public roleIds: string[];
    static get url(): string {
        return "api/account/register";
    }
}
export class Widget {
    isEditable: boolean;
    widgeth: number;
    widgetid: number;
    widgetpage: string;
    widgetrolefilters: WidgetRoleFilter[];
    widgetsetting: WidgetSetting[];
    widgettype: number;
    widgetuser: string;
    widgetuserfilters: WidgetUserFilter[];
    widgetw: number;
    widgetx: number;
    widgety: number;
}
export class WidgetType {
    wtypeenable: number;
    wtypeid: number;
    wtypename: string;
}
export class WidgetFilter {
    filterbackgroundcolor: string = null;
    filtercolor: string = null;
    filterdesc: string = null;
    filtericon: string = null;
    filterid: number = null;
    filterseqnr: number = null;
    filtertext: string = 'Leerer Filter';
    filtertype: string = null;
    filterwidget: number = null;
    filter: number = null;
    filteR1: Filter = null;
    filtersortattribute: string = null;
    filtersortdsc: boolean = false;
}
export class WidgetRoleFilter {

}
export class WidgetUserFilter extends WidgetFilter {
    filteruser: string = null;
}
export class Filter {
    filterid: number;
    type: string;
    sortingattribute: string;
    sortingdesc: boolean;
    filterparent: number;
    parent: number;
    filteR1: Filter[];
    filtercondition: FilterCondition[];
    isNew: boolean;
    isCurrentlySaving: boolean;
    mathJSNode?: any;
}
export class FilterCondition {
    id: number;
    attribute: string;
    value: string;
    isnot: boolean;
    operation: number;
    filterid: number;
}
export const FilterConditionOperation = {
    EQUAL: 0,
    UNEQUAL: 1,
    INCLUDES: 2,
    INCLUDESNOT: 3
}
export class WidgetSetting {
    widgetid: number;
    widgetsettingdesc: string;
    widgetsettingid: number;
    widgetsettingvalue: string;
}
export class HistoryModel {
    historyid: number;
    historydate: string;
    historyterm: string;
}
export class ContractHistoryModel extends HistoryModel {
    historycontract: number;
    contract: Contract;
    customer: string;
    state: string;
    type: string;
}
export class ContractOverviewModel {
    contractid: number;
    contractdesc: string;
    contractnumber: string;
    customer: string;
    state: string;
    type: string;
    accessed: string;
    favstate: boolean;
}
export class CustomerOverviewModel {
    customerid: number;
    customernumber: string;
    customername: string;
    customermail: string;
    customerfax: string;
    customerphone: string;
    customeractive: boolean;
    accessed: string;
    favstate: boolean;
}
export class ContactpersonalOverviewModel {
    contactpersid: number;
    contactpersfname: string;
    contactperslname: string;
    contactperssalutation: string;
    contactperspublicid: string;
    contactpersondepartment: string;
    phone: string;
    email: string;
    fax: string;
    mobile: string;
    accessed: string;
}
export class IssueOverviewModel {
    public issuetype: number;
    public issueid: number;
    public issuepriority: number;
    public issuestate: number;
    public issuetitle: string;
    public issuecreation: string;
    public issueescalation: string;
    public issuenumber: number;
    public isintroduced: boolean;
    public isnew: boolean;
    public iswatched: boolean;
    public state: string;
    public statecolor: string;
    public customer: string;
    public category: string;
    public changetype: string;
    public laststatuschange: string;
}
export class OfferOverviewModel {
    public offercreation: string;
    public offercreator: string;
    public offerdesc: string;
    public offerid: number;
    public offerstate: string;
    public offertitle: string;
}
export class SubTitleWrapper {
    value: string;
    type: string;
}
export class TransformIncidentToIssueResponse {
    incident: Issue;
    issue: Issue;
}
export class TransformOfferToIssueResponse {
    offer: Offer;
    issue: Issue;
}